module.exports = __webpack_public_path__ + "img/an.40e2ecee.png";